module.exports = __webpack_public_path__ + "img/global-shipping.86ec76b4.png";